import { PDFDocument } from 'pdf-lib';
import { Annotation } from '../components/annotation/annotation';
import { annotationToPdfPointsTopDown } from '../components/annotation/annotation-geometry';
import { VisibleSignatureOptions } from '../../../use-cases/sign-uploaded-document';

// Converts one annotation into PDF point coordinates for the backend's
// visible-signature stamp. Purely from the stored page-relative values
// (x / containerRect.width, ...) and the page's size in points: no DOM measurement,
// so the result does not depend on what is on screen when signing.
export const buildVisibleSignatureOptionsForAnnotation = (
	annotation: Annotation,
	pdfDoc: Pick<PDFDocument, 'getPage'>,
	userName: string,
): VisibleSignatureOptions => {
	const page = pdfDoc.getPage(annotation.page);
	const rect = annotationToPdfPointsTopDown(annotation, {
		width: page.getWidth(),
		height: page.getHeight(),
	});

	return {
		page_number: annotation.page,
		position_x: rect.x,
		// Top-down (0 = top edge). DSS's SignatureFieldParameters#setOriginY (used for
		// the primary/real signature field in SignPDF.signPadesVisible) expects this
		// same top-down value - do not flip it here. Any "extra" stamps placed via raw
		// PDFBox (SignPDF.bakeExtraStamps) need PDFBox's bottom-up convention instead,
		// but that conversion belongs on the backend, next to the PDFBox code that
		// actually needs it - not here, since this one value feeds both mechanisms and
		// they disagree on orientation.
		position_y: rect.y,
		width: rect.width,
		height: rect.height,
		include_date: true,
		include_initials: false,
		include_motive: true,
		include_signature_graphic: true,
		motive: `firmado electronicamente por ${userName}`,
	};
};
